/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import axios from "axios";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_PRESENTATIONS, GET_SECTION_OPTIONS } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import config from "../config/analyticsWidget.config.json";
import { templateReplacer } from "../../../helpers/template.replace";
import { pretty } from "@vlinder-web/utils-react";
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};
export interface ISalesCostumeInventoryMethods extends IPluginMethodMap {
  getCostume(args: any): Promise<any>;
}
export class SalesCostumeInventoryService implements IAgentPlugin {
  readonly methods: ISalesCostumeInventoryMethods;
  constructor() {
    this.methods = {
      getCostume: this.getCostumeProps.bind(this),
    };
  }
  async getCostumeProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    let addOnFilter = {};

    console.log("args in grpah===", args?.criteria);

    const filter = {};
    try {
      if (client) {
        const _res = await client.query({
          query: GET_PRESENTATIONS,
          variables: {
            filter: filter,
            options: {
              limit: 10,
              skip: 0,
              sort: {
                field: "status",
                order: "asc",
              },
            },
          },
          fetchPolicy: "network-only",
        });
        const defaultPresentation =
          _res?.data?.getPresentations?.content[0]?.id;
        if (args?.criteria === "") {
          args.criteria = defaultPresentation;
        }
        addOnFilter = {
          filter: {
            presentation: {
              eq: args?.criteria?.status ?? defaultPresentation,
            },
          },
        };
        if (args?.criteria?.startDate && args?.criteria?.endDate) {
          addOnFilter = {
            filter: {
              presentation: {
                eq: args?.criteria?.status ?? defaultPresentation,
              },
              createdAt: {
                gte: args?.criteria?.startDate,
                lte: args?.criteria?.endDate,
              },
              inactive___date: {
                gte: args?.criteria?.startDate,
                lte: args?.criteria?.endDate,
              },
            },
          };
        }
        const now = new Date();

        // Start of local day
        const startOfDay = new Date(now);
        startOfDay.setHours(0, 0, 0, 0);

        // End of local day
        const endOfDay = new Date(now);
        endOfDay.setHours(23, 59, 59, 999);

        // Utility to convert to "local ISO-like string"
        function toLocalISOString(date: Date) {
          const tzOffset = date.getTimezoneOffset() * 60000; // offset in ms
          const localTime = new Date(date.getTime() - tzOffset);
          return localTime.toISOString().slice(0, -1) + "Z";
        }

        // Manually format with +05:30
        const formatIST = (date: any) => date.replace("Z", "+05:30");
        let addOnFilter1 = {
          filter: {
            presentation: {
              eq: args?.criteria?.status ?? defaultPresentation,
            },
            createdAt: {
              gte: formatIST(toLocalISOString(startOfDay)),
              lte: formatIST(toLocalISOString(endOfDay)),
            },
            inactive___date: {
              gte: formatIST(toLocalISOString(startOfDay)),
              lte: formatIST(toLocalISOString(endOfDay)),
            },
          },
        };
        console.log(addOnFilter1);

        const res = await client.query({
          query: GET_SECTION_OPTIONS,
          variables: {
            ...addOnFilter,
          },
          fetchPolicy: "network-only",
        });

        const res1 = await client.query({
          query: GET_SECTION_OPTIONS,
          variables: {
            ...addOnFilter1,
          },
          fetchPolicy: "network-only",
        });

        if (res && res1) {
          let formattedData1 = this.formatTable(
            res?.data?.getSalesReport?.content
          );
          let formattedData2 = this.formatTable(
            res1?.data?.getSalesReport?.content
          );
          let formattedConfig = this.getTransformConfig(
            config,
            formattedData1[0]?.result,
            formattedData1[0]?.label
          );
          console.log("foarmatted data is====", pretty(formattedData1));
          return {
            response: formattedConfig,
            totalActive: formattedData1[0]?.totalActive,
            totalDeleted: formattedData1[0]?.totalDeleted,
            totalCurrentCountActive: formattedData2[0]?.totalActive,
            totalCurrentCountDeleted: formattedData2[0]?.totalDeleted,
            typeOfSearch: _res?.data?.getPresentations?.content?.map(
              (_item: any) => {
                return { value: _item?.id, label: _item?.name };
              }
            ),
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return {
        isEmpty: true,
      };
    }
  }
  private getTransformConfig(data: any, result?: any[], labels?: any[]) {
    let _data = data.layout[0].colProps[0].compProps.salesValue.day;
    _data.chartSeries = result;
    _data.labels = labels;
    const jsonString = JSON.stringify(data);
    console.log("jsonString 107===>", jsonString);
    return JSON.parse(jsonString);
  }

  private formatTable = (data: any[]): any[] => {
    console.log(data);
    const colors = [
      "#8268F3",
      "#E2C614",
      "#78CFA8",
      "#90A765",
      "#E6203C",
      "#E1B655",
      "#15660A",
      "#1B6D98",
      "#5FD30C",
      "#B06943",
      "#236445",
      "#03E4EA",
      "#DDE628",
      "#080B54",
      "#CE9938",
      "#3FBA8F",
      "#B376CD",
      "#23702F",
      "#9C9915",
      "#E82E5C",
      "#BA9365",
      "#251998",
      "#681ABD",
      "#514745",
      "#E2654C",
      "#07DE7F",
      "#555E9F",
      "#D175EE",
      "#100E27",
      "#AB2F79",
      "#0EF51A",
      "#2B2417",
      "#4B3F74",
      "#3FE645",
      "#B6FA34",
      "#1216A0",
      "#59085E",
      "#D428BC",
      "#39E9D0",
      "#F4EA96",
      "#068EC1",
      "#E6793E",
      "#F9A472",
      "#B60E03",
      "#D05AA2",
      "#793FD0",
      "#53DB5E",
      "#3C6E9A",
      "#5A8EAA",
      "#05739F",
      "#55CE58",
      "#AC81F9",
      "#FDA8FB",
      "#03F498",
      "#2C82AB",
      "#3B0E98",
      "#725B2B",
      "#07D0B0",
      "#C45F20",
      "#75B147",
      "#0ACB8F",
      "#18CCEF",
      "#421099",
      "#69BECA",
      "#E11F0B",
      "#74178B",
      "#DBA6E8",
      "#E59969",
      "#803229",
      "#709A6F",
      "#1B78FF",
      "#E3B80B",
      "#440301",
      "#C8EC61",
      "#614745",
      "#CF6C3A",
      "#22794B",
      "#24F3E8",
      "#7E28FC",
      "#038C6F",
      "#369235",
      "#6DE601",
      "#8E8F43",
      "#119287",
      "#6EFE26",
      "#73A3FB",
      "#9DF55F",
      "#1DC358",
      "#698964",
      "#C9CB8D",
      "#57E376",
      "#1886A6",
      "#B3566E",
      "#3A03D7",
      "#23CA58",
      "#1600AC",
      "#14C845",
      "#8A5189",
      "#E81801",
      "#09131D",
      "#881B0A",
      "#E09CE3",
      "#A4C513",
      "#E0C669",
      "#A2181B",
      "#3A1D19",
      "#F6E088",
      "#F04B11",
      "#B0DD8D",
      "#2CAD3D",
      "#51700E",
      "#296A58",
      "#4A2F46",
      "#E3180E",
      "#D137BA",
      "#60468B",
      "#3CFE09",
      "#686E47",
      "#7147BB",
      "#07E6F2",
      "#B30555",
      "#DDC60D",
      "#9A3FBE",
      "#AECF3F",
      "#7231B3",
      "#B870D6",
      "#1472DF",
      "#16DE56",
      "#4C43D3",
      "#083C28",
      "#6DF6C2",
      "#8377FB",
      "#74FA03",
      "#96E4AA",
      "#399DF7",
      "#418E13",
      "#541C15",
      "#C1D9C8",
      "#EA3D66",
      "#BBC7C1",
      "#652168",
      "#432701",
      "#54BC1F",
      "#62965D",
      "#C8F233",
      "#52AE6B",
      "#985A2E",
      "#7032F6",
      "#1BEB88",
      "#670310",
      "#6195BD",
      "#68A38D",
      "#B53DB1",
      "#597B2F",
      "#4A9403",
      "#712F4B",
      "#FDE04F",
      "#A92794",
      "#C32DBE",
      "#73379B",
      "#7DFA1A",
      "#6C44E4",
      "#B69D2F",
      "#550463",
      "#1DA4DF",
      "#9ED6B6",
      "#85073B",
      "#6F83B5",
      "#AF7013",
      "#04E1ED",
      "#AB32DA",
      "#42C350",
      "#540A41",
      "#D0980E",
      "#67B114",
      "#68210C",
      "#941A7B",
      "#2DFF74",
      "#FEBBDF",
      "#87C59A",
      "#A316B3",
      "#735D3E",
      "#88BCC0",
      "#597E1D",
      "#1ED0F3",
      "#4981EA",
      "#12ECEB",
      "#CC8EA6",
      "#48577E",
      "#D60D55",
      "#CBB741",
      "#652F60",
      "#81E982",
      "#7D5347",
      "#8CAA75",
      "#9ABED8",
      "#3216BD",
      "#B5D892",
      "#1CCA2F",
      "#B4C6B3",
      "#474D5E",
      "#5EE3A1",
    ];
    const uniqueSections = [
      ...new Set(
        data
          .filter((item) => item.section && item.section.name)
          .map((item) => item.section.name)
      ),
    ].sort((a, b) => a.localeCompare(b));

    const uniqueNames = [...new Set(data.map((item) => item.sectionOptType))];
    console.log(uniqueNames);
    const resultActive = uniqueNames.map((name) => ({
      name: `${name} - Active`,
      status: "active",
      data: uniqueSections.map((section) => {
        const count = data
          .filter(
            (item) =>
              item?.sectionOptType === name &&
              item?.section &&
              item?.section?.name === section
          )
          .reduce((sum, item) => sum + item?.Activecount, 0);
        return count;
      }),
    }));
    const resultDeleted = uniqueNames.map((name) => ({
      name: `${name} - Deleted`,
      status: "deleted",
      data: uniqueSections.map((section) => {
        const count = data
          .filter(
            (item) =>
              item?.sectionOptType === name &&
              item?.section &&
              item?.section?.name === section
          )
          .reduce((sum, item) => sum + item?.Deletedcount, 0);
        return count;
      }),
    }));
    let result = [...resultActive, ...resultDeleted];
    result.sort((a, b) => a.name.localeCompare(b.name));
    let colorCount = 0;
    result.forEach((obj) => {
      console.log(obj.name.toLowerCase());
      if (
        obj.name.toLowerCase() === "female - active" &&
        obj?.status !== "deleted"
      ) {
        obj.color = "#FFB6DD";
      } else if (
        obj.name.toLowerCase() === "male - active" &&
        obj?.status !== "deleted"
      ) {
        obj.color = "#191970";
      } else {
        obj.color = colors[colorCount++];
      }
      console.log("color==>", obj.color);
    });
    let totalAct = 0;
    let totalDel = 0;

    result.forEach((item: any) => {
      let c = 0;
      for (let i = 0; i < item?.data.length; i++) {
        console.log(item);
        c += item?.data[i];
      }
      if (item?.status == "active") {
        totalAct += c;
      }
      if (item?.status == "deleted") {
        totalDel += c;
      }
      item.name = `${item?.name} (${c})`;
      console.log("result==>", item?.name, totalAct, totalDel);
    });
    let resArray: any[] = [];
    resArray.push({
      result: result,
      label: uniqueSections,
      totalActive: totalAct,
      totalDeleted: totalDel,
    });
    return resArray;
  };
}
